import { EdiFuncAck } from "../EdiFuncAck";
import { EdiStatusDetailTab } from "../EdiStatusDetailTab";
import { EdiStatusGeneralLayout } from "../EdiStatusGeneralLayout";
import { EdiStatusOrderTab } from "../EdiStatusOrderTab";
import { Button, DataHeader, DataSource, HorizontalSpacer, Image, Label, Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutViewEdiStatus extends Layout {
    buttonFuncAckRawData: Button;
    buttonStatusRawData: Button;
    classicButton: Button;
    horizontalspacer5: HorizontalSpacer;
    horizontalspacer6: HorizontalSpacer;
    imageGoToOrder: Image;
    labelOrderId: Label;
    labelOrderNumber: Label;
    labelOrderStatus: Label;
    labelShipmentStatusTitle: Label;
    layoutComments: Layout;
    layoutEdiStatusDetailTabLayout: EdiStatusDetailTab;
    layoutEdiStatusOrderTab: EdiStatusOrderTab;
    layoutFA: EdiFuncAck;
    layoutGeneral: EdiStatusGeneralLayout;
    sourceEdiFunctionalAck: DataSource;
    sourceEdistatus: DataSource;
    sourceEdistatusComment: DataSource;
    statusdataheader: DataHeader;
    tabComments: Tab;
    tabFuncAck: Tab;
    tabOrder: Tab;
    tabOverview: Tab;
    tabStatus: Tab;
    tabsetStatus: Tabset;
}
